import { Phone } from './phone.model';
import { TransferFormModel } from './edit-fac-modal.model';

export interface FacChartsModel {
  green: number;
  yellow: number;
  red: number;
  total?: number;
}

export interface Payload {
  payload: ColumnDashboard []
}
export interface ColumnDashboard {
  id: string;
  funnel_stage: string;
  title: string;
  facs: Facs [];
}

export interface Facs {
  id: string;
  phone: Phone;
  email: string;
  product: string;
  name: string;
  badges: Badges[];
  color: number;
  last_update_date: Date;
  visit_date: Date;
  date_return: string;
  contact: Date;
  temperature: string;
  is_favorite: boolean;
  interest: string;
  funnel_stage: Funnel;
  user_full_name: string;
  user_nickname: string;
  isCall?: boolean;
}

export interface Funnel {
  value: string;
  sub_items: string [];
}
export interface Badges {
  name: string;
  description: string;
}

export interface Favorite {
  id: string;
  is_favorite: boolean;
}

export interface TransferPackModel {
  fac_ids: string [];
  user: TransferFormModel;
}

export interface UpdateFacs {
  id: string;
  stage: Stage;
}

export interface Stage {
  above_fac_id: string;
  below_fac_id: string;
}

export interface SendOpenModal {
  id: string;
  openModal: boolean;
}

export interface FilterFacs {
  fields: string;
  color: number;
  temperature: string;
  is_favorite: boolean;
  badges: string;
  filters?: Field [];
}

export interface Field {
  field: string;
  value: string;
  match: string;
}

export interface Person {
  name: string;
  phone: string;
  email: string;
}
export interface Temperature {
  name: string;
}

export interface FunnelStage {
  value: string;
}

export interface AutoComplite {
  description: string;
  type: string;
  field: string;
}

export interface OrderCard {
  above_fac_id: string;
  below_fac_id: string;
}

export interface RespTransferPost {
  status: {
    id: number,
    name:string
  },
  messages: [
      {
        code: string,
        message: string,
        type: string
      }
  ],
  task_id: string,
  taskId: string
}

export const HeaderTableFacs = [
  {
    id: 0,
    nameClass: '',
    data: 'input',
  },
  {
    id: 1,
    nameClass: 'name',
    data: 'Nome',
  },
  {
    id: 2,
    nameClass: 'product',
    data: 'Produto',
  },
  {
    id: 3,
    nameClass: 'stage',
    data: 'Estágio',
  },
  {
    id: 5,
    nameClass: 'contact',
    data: 'Contato',
  },
  {
    id: 6,
    nameClass: 'temp',
    data: 'Temperatura',
  },
  {
    id: 7,
    nameClass: 'indicators',
    data: 'Indicadores',
  },
  {
    id: 8,
    nameClass: 'data',
    data: 'Data',
  }
];

export const HeaderTableFacsV2 = [
  {
    id: 0,
    nameClass: '',
    data: 'input',
  },
  {
    id: 1,
    nameClass: 'name',
    data: 'Nome',
  },
  {
    id: 2,
    nameClass: 'product',
    data: 'Produto',
  },
  {
    id: 3,
    nameClass: 'stage',
    data: 'Estágio',
  },
  {
    id: 4,
    nameClass: 'broker',
    data: 'Corretor',
  },
  {
    id: 5,
    nameClass: 'contact',
    data: 'Contato',
  },
  {
    id: 6,
    nameClass: 'temp',
    data: 'Temperatura',
  },
  {
    id: 7,
    nameClass: 'indicators',
    data: 'Indicadores',
  },
  {
    id: 8,
    nameClass: 'data',
    data: 'Data',
  }
];